<div class="rp-header">
  <div class="rp-header__left">
    <div class="rp-header__icon"><mat-icon>show_chart</mat-icon></div>
    <div>
      <h1 class="rp-header__title">Resumen</h1>
      <p class="rp-header__sub">Visión general de ingresos, gastos y resultados</p>
    </div>
    <app-tutorial-button tutorial="recorrido-general"></app-tutorial-button>
  </div>
  <mat-slide-toggle
    [checked]="showGlobal"
    (change)="showGlobal = $event.checked; changeGlobal()">
    Mostrar todas las actividades
  </mat-slide-toggle>
</div>

<div class="col-md-12">
  <mat-tab-group class="mt-3 w-100" [preserveContent]="true">
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon style="font-size:18px;width:18px;height:18px;margin-right:6px;">show_chart</mat-icon>
        Resumen total
      </ng-template>
      <ng-template matTabContent>
        <ng-container *ngIf="readyExpenses == false || readyIncomes == false">
          <div class="container text-center">
            <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
          </div>
        </ng-container>
        <ng-container *ngIf="readyExpenses && readyIncomes">
          <chart-resume-total
            [dataV2]="dataV2"
            [resumeToday]="resumeToday"
            [showGlobal]="showGlobal">
          </chart-resume-total>
        </ng-container>
      </ng-template>
    </mat-tab>

    <mat-tab *ngIf="useIGIC">
      <ng-template mat-tab-label>
        <mat-icon style="font-size:18px;width:18px;height:18px;margin-right:6px;">assessment</mat-icon>
        Resumen IGIC
      </ng-template>
      <ng-template matTabContent>
        <ng-container *ngIf="readyExpenses == false || readyIncomes == false">
          <div class="container text-center">
            <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
          </div>
        </ng-container>
        <ng-container *ngIf="readyExpenses && readyIncomes">
          <chart-resume-igic
            [dataV2]="dataV2"
            [showGlobal]="showGlobal">
          </chart-resume-igic>
        </ng-container>
      </ng-template>
    </mat-tab>

    <mat-tab *ngIf="useIVA">
      <ng-template mat-tab-label>
        <mat-icon style="font-size:18px;width:18px;height:18px;margin-right:6px;">assessment</mat-icon>
        Resumen IVA
      </ng-template>
      <ng-template matTabContent>
        <ng-container *ngIf="readyExpenses == false || readyIncomes == false">
          <div class="container text-center">
            <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
          </div>
        </ng-container>
        <ng-container *ngIf="readyExpenses && readyIncomes">
          <chart-resume-iva
            [dataV2]="dataV2"
            [showGlobal]="showGlobal">
          </chart-resume-iva>
        </ng-container>
      </ng-template>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon style="font-size:18px;width:18px;height:18px;margin-right:6px;">check_circle</mat-icon>
        Gestión de cobros
      </ng-template>
      <ng-template matTabContent>
        <ng-container *ngIf="readyExpenses == false || readyIncomes == false">
          <div class="container text-center">
            <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
          </div>
        </ng-container>
        <ng-container *ngIf="readyExpenses && readyIncomes">
          <chart-resume-earning
            [dataV2]="dataV2"
            [showGlobal]="showGlobal">
          </chart-resume-earning>
        </ng-container>
      </ng-template>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon style="font-size:18px;width:18px;height:18px;margin-right:6px;">payment</mat-icon>
        Gestión de pagos
      </ng-template>
      <ng-template matTabContent>
        <ng-container *ngIf="readyExpenses == false || readyIncomes == false">
          <div class="container text-center">
            <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
          </div>
        </ng-container>
        <ng-container *ngIf="readyExpenses && readyIncomes">
          <chart-resume-paided
            [dataV2]="dataV2"
            [showGlobal]="showGlobal">
          </chart-resume-paided>
        </ng-container>
      </ng-template>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon style="font-size:18px;width:18px;height:18px;margin-right:6px;">insert_chart</mat-icon>
        Resumen resultados
      </ng-template>
      <ng-template matTabContent>
        <ng-container *ngIf="readyExpenses && readyIncomes">
          <resume-result [showGlobal]="showGlobal"></resume-result>
        </ng-container>
      </ng-template>
    </mat-tab>

    <mat-tab label="Informe IA">
      <mat-tab-group class="mt-2 w-100">
        <mat-tab label="Recomendaciones">
          <app-recomendaciones></app-recomendaciones>
        </mat-tab>
        <mat-tab label="Informe Detallado">
          <app-ai-reports></app-ai-reports>
        </mat-tab>
      </mat-tab-group>
    </mat-tab>
  </mat-tab-group>
</div>
